import Vue from 'vue'
import App from './App.vue'
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { createStore } from './store/index'
import { createRouter } from './router/index'
import { sync } from 'vuex-router-sync' // 把当前VueRouter状态同步到Vuex中
import mixinEventHandler from './lib/js/mixin/xpubEventHandler.js'
import { showToast, getPubData, setPubData } from './lib/js/utils'
import { invokeEvent } from './lib/js/event/event-center/index'
import * as eventActions from './lib/js/event/general-event-list/index'
import { trackEvent } from './lib/js/trackEvent/index'
import fn from './store/exposeApi'
import { initWebx } from './lib/js/init.js'

initWebx()

const router = createRouter()
const store = createStore()

if (!__isServerRender__) {
  window.store = store
  window.router = router
  window.__EVENT_ACTIONS = eventActions
  window.D = webx // 老组件兼容
  window.__XPUB__ = fn || {}
  // 静态资源加载情况埋点上报
  window.PerfTrack.jsReady()
  // 埋点: 开始加载页面
  trackEvent('userteam_ad_zj_begin_en')
  if (window.__INITIAL_STATE__?.prefetched) {
    window.PerfTrack.requestBegin()
    window.PerfTrack.responseReady()
  }
}

Vue.mixin(mixinEventHandler)
Vue.prototype.$showToast = showToast
Vue.prototype.$getPubData = getPubData
Vue.prototype.$setPubData = setPubData
Vue.prototype.$invokeEvent = invokeEvent

export const createApp = () => {
  sync(store, router)
  const app = new Vue({ router, store, render: h => h(App) })
  return { app, router, store }
}
